import React, { useEffect, useState } from 'react';
import Header from '../Common/AdminHeader';
import AdminMessageCard from '../../../Shared components/AdminMessageCard';
import axios from 'axios';
import { Config } from '../../../API/config';
import { Message } from '../../../types/AdminMessages';
import { Toaster } from 'react-hot-toast';
import { FaSearch } from 'react-icons/fa';

const ManageMessage = () => {
    const [messages, setMessages] = useState<Message[]>([]);
    const [filteredMessages, setFilteredMessages] = useState<Message[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedChat, setSelectedChat] = useState<Message | null>(null);
    const [chatMessages, setChatMessages] = useState<any>();
    const [chatLoading, setChatLoading] = useState(false);

    const getAllPendingMessages = async () => {
        try {
            setLoading(true);
            let { data } = await axios.get(Config.getAllPendingMessages, { withCredentials: true });
            if (data.statusCode === 200) {
                setMessages(data.data);
                setFilteredMessages(data.data);
            }
        } catch (err) {
            console.error("Error fetching Messages data:", err);
        } finally {
            setLoading(false);
        }
    };

    const getChatMessages = async (senderId: string, receiverId: string) => {
        try {
            setChatLoading(true);
            const { data } = await axios.get(`${Config.getChatBySenderReceiverId}/${senderId}/${receiverId}`,
                { withCredentials: true }
            );
            if (data.statusCode === 200) {
                const sortedMessages = {
                    ...data.data, messages: data.data.messages.sort((a: any, b: any) =>
                        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
                    )
                };
                setChatMessages(sortedMessages);
            }
        } catch (err) {
            console.error("Error fetching chat messages:", err);
        } finally {
            setChatLoading(false);
        }
    };

    useEffect(() => {
        getAllPendingMessages();
    }, []);

    useEffect(() => {
        if (searchTerm.trim() === "") {
            setFilteredMessages(messages);
        } else {
            const filtered = messages.filter((msg) =>
                (msg.receiverId?.name.toLowerCase().includes(searchTerm.toLowerCase()) || false) ||
                (msg.senderId.name?.toLowerCase().includes(searchTerm.toLowerCase()) || false)
            );
            setFilteredMessages(filtered);
        }
    }, [searchTerm, messages]);

    const handleReadChat = (message: Message) => {
        setSelectedChat(message);
        if (message.senderId?._id && message.receiverId?._id) {
            getChatMessages(message.senderId._id, message.receiverId._id);
        }
    };

    const closeChatModal = () => {
        setSelectedChat(null);
        setChatMessages(undefined);
    };


    return (
        <div className="flex-1 overflow-auto relative z-10 bg-white">
            <Toaster />
            <Header title={"ادارة الرسائل"} />

            <main className="max-w-7xl mx-auto py-6 px-4 lg:px-8">
                <div className="relative mb-4 flex justify-end">
                    <input
                        type="text"
                        placeholder="ابحث عن رسالة..."
                        className="w-full md:w-1/2 p-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                </div>
                <div className="flex flex-col md:flex-row flex-wrap justify-center gap-4">
                    {loading ? (
                        Array(6)
                            .fill(null)
                            .map((_, index) => (
                                <div
                                    key={index}
                                    className="w-72 p-4 bg-gray-100 rounded-lg shadow animate-pulse"
                                >
                                    <div className="h-5 w-1/2 bg-gray-300 rounded mb-2"></div>
                                    <div className="h-4 w-3/4 bg-gray-300 rounded mb-2"></div>
                                    <div className="h-24 w-full bg-gray-300 rounded"></div>
                                </div>
                            ))
                    ) : filteredMessages.length > 0 ? (
                        filteredMessages.map((msg, idx) => (
                            <div key={idx} className="relative">
                                <AdminMessageCard message={msg} update={getAllPendingMessages} />
                                <button
                                    onClick={() => handleReadChat(msg)}
                                    className="mt-2 w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition-colors"
                                >
                                    أقرا الشات
                                </button>
                            </div>
                        ))
                    ) : (
                        <p className="text-center text-gray-600 w-full">لا توجد رسائل مطابقة</p>
                    )}
                </div>
            </main>

            {/* Chat Modal */}
            {selectedChat && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-md max-h-[80vh] overflow-y-auto">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-semibold">
                                <div> <span>{selectedChat.senderId?.name}</span> و <span>{selectedChat.receiverId?.name}</span> :محادثة بين</div>
                            </h3>
                            <button
                                onClick={closeChatModal}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                ✕
                            </button>
                        </div>
                        <div className="space-y-4">
                            {chatLoading ? (
                                <p className="text-center">جاري تحميل المحادثة...</p>
                            ) : chatMessages && chatMessages.messages && chatMessages.messages.length > 0 ? (
                                chatMessages.messages.map((chat: any, index: any) => (
                                    <div
                                        key={chat._id || index}
                                        className={`p-3 rounded-lg ${chat.senderId === selectedChat.senderId?._id
                                                ? 'bg-blue-100 ml-auto text-right'
                                                : 'bg-gray-100 mr-auto text-right'
                                            } max-w-[70%]`}
                                    >
                                        <p className="text-sm font-semibold">
                                            {chat.senderId === selectedChat.senderId?._id
                                                ? selectedChat.senderId?.name
                                                : selectedChat.receiverId?.name}
                                        </p>
                                        <p className="mt-1">{chat.content}</p>
                                        <span className="text-xs text-gray-500 block mt-1">
                                            {new Date(chat.createdAt).toLocaleString('ar-EG', {
                                                dateStyle: 'short',
                                                timeStyle: 'short'
                                            })}
                                        </span>
                                        {chat.status && (
                                            <span className="text-xs text-red-500 block mt-1">
                                                {chat.status}: الحالة
                                            </span>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <p className="text-center text-gray-600">لا توجد رسائل في المحادثة</p>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ManageMessage;